import { Controller } from 'react-hook-form';
import Checkbox from '@/components/checkbox';
import PropTypes from 'prop-types';

function CheckboxController({
  className,
  inputName,
  inputId,
  control,
  rules,
  label,
  children,
  handleOnChange,
  defaultValue,
  hiddenCheckbox,
}) {
  return (
    <Controller
      name={inputId}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({
        field: { onChange, onBlur, value },
        fieldState: { error },
      }) => (
        <Checkbox
          className={className}
          id={inputId}
          name={inputName}
          label={label}
          error={error?.message || ''}
          onChange={(e) => {
            onChange(e);
            handleOnChange(e);
          }}
          onBlur={onBlur}
          value={value}
          checked={defaultValue}
          hiddenCheckbox={hiddenCheckbox}
        >
          {children}
        </Checkbox>
      )}
    />
  );
}
CheckboxController.propTypes = {
  handleOnChange: PropTypes.func,
};

CheckboxController.defaultProps = {
  handleOnChange: () => {},
};
export default CheckboxController;
